import { Component } from '@angular/core';
import { AppConfig, Redirection } from '@tytapp/common';
import { environment } from 'environments/environment';

@Component({
  selector: 'tyt-one-time-offer-notice',
  templateUrl: './one-time-offer-notice.component.html',
  styleUrls: ['./one-time-offer-notice.component.scss']
})
export class OneTimeOfferNoticeComponent {

  constructor(
    private redirection: Redirection,
    private appConfig: AppConfig
  ) { }
  
  get appUrl() {
    return environment.urls.app;
  }
}
